// extracted by mini-css-extract-plugin
module.exports = {"textContent":"schedule-module--textContent--56YoE"};